import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { getCurrencyCode } from 'utils/helpers';

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moveDirection: 'forward',
      previousProgressIndex: props.progressIndex - 1,
    };
  }

  UNSAFE_componentWillReceiveProps({ progressIndex }) {
    const currentProgressIndex = this.props.progressIndex;
    let previousProgressIndex = currentProgressIndex;
    if (progressIndex > currentProgressIndex) {
      previousProgressIndex = progressIndex - 1;
    } else if (progressIndex < currentProgressIndex) {
      previousProgressIndex = progressIndex + 1;
    }
    if (progressIndex !== currentProgressIndex) {
      this.setState({
        moveDirection: progressIndex > currentProgressIndex ? 'forward' : 'backward',
        previousProgressIndex,
      });
    }
  }

  render() {
    const {
      visibleSteps, progressIndex, hidesStepTitle, type,
    } = this.props;
    const { moveDirection, previousProgressIndex } = this.state;
    const isFirstStep = progressIndex === 0;
    const isMovingForward = moveDirection === 'forward';
    const isMovingBackward = moveDirection === 'backward';
    const animationsDisabled = isFirstStep && previousProgressIndex === -1;
    const progressBarClasses = cx({
      'progress-bar': true,
      [`progress-bar--${getCurrencyCode()}`]: true,
      [`progress-bar--type-${type}`]: type,
    });
    const indicatorClasses = cx({
      'progress-bar__indicator': true,
      'progress-bar__indicator--move-forward': !isFirstStep && isMovingForward,
      'progress-bar__indicator--move-backward': isMovingBackward,
    });

    return (
      <ul className={progressBarClasses}>
        {visibleSteps.map((item, index) => {
          const isActiveStep = index === progressIndex;
          const bulletClasses = cx({
            'progress-bar__bullet': true,
            'progress-bar__bullet--past': index < progressIndex,
            'progress-bar__bullet--current': isActiveStep,
            'progress-bar__bullet--animated-past-current': isActiveStep && isMovingForward,
            'progress-bar__bullet--animated-current-past': isActiveStep && isMovingBackward,
            'no-animation': animationsDisabled,
          });
          return (
            <li key={item.type} className={bulletClasses}>
              {!hidesStepTitle && isActiveStep
                && (
                <span
                  className={cx({
                    'progress-bar__title': true,
                    'no-animations': animationsDisabled,
                  })}
                >
                  <FormattedMessage id={`navigation.step.${item.type}`} />
                </span>
                )}
              {isActiveStep
                && (
                <span className={indicatorClasses}>
                  <span
                    className={cx({
                      'progress-bar__indicator-bullet': true,
                      'no-animations': animationsDisabled,
                    })}
                  />
                </span>
                )}
            </li>
          );
        })}
      </ul>
    );
  }
}

ProgressBar.propTypes = {
  visibleSteps: PropTypes.array,
  progressIndex: PropTypes.number,
  hidesStepTitle: PropTypes.bool,
  type: PropTypes.string,
};

export default ProgressBar;
